import { toDateTimeLocal } from "../lib/date";

interface Props {
  // Valeur au format datetime-local : "YYYY-MM-DDTHH:mm" (drop-in du <input datetime-local>).
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  // Id du champ date, pour un <label htmlFor> externe ; sinon il porte « Date ».
  id?: string;
  // Affiche le raccourci "Maintenant" (par défaut true).
  allowNow?: boolean;
}

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0"),
);

export function DateTimeField({
  value,
  onChange,
  required,
  id,
  allowNow = true,
}: Props) {
  const [datePart = "", timePart = ""] = value.split("T");
  const [hh = "", mm = ""] = timePart.split(":");

  function emit(date: string, h: string, m: string) {
    if (!date && !h && !m) {
      onChange("");
      return;
    }
    onChange(`${date}T${h || "00"}:${m || "00"}`);
  }

  return (
    <div className="dt-field">
      <input
        className="field dt-field__date"
        type="date"
        id={id}
        aria-label={id ? undefined : "Date"}
        value={datePart}
        onChange={(e) => emit(e.target.value, hh, mm)}
        required={required}
      />
      <div className="dt-field__time">
        <select
          className="field"
          value={hh}
          onChange={(e) => emit(datePart, e.target.value, mm)}
          required={required}
          aria-label="Heures"
        >
          <option value="" disabled>
            HH
          </option>
          {HOURS.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
        <span className="dt-field__sep">:</span>
        <select
          className="field"
          value={mm}
          onChange={(e) => emit(datePart, hh, e.target.value)}
          required={required}
          aria-label="Minutes"
        >
          <option value="" disabled>
            MM
          </option>
          {MINUTES.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>
      {allowNow && (
        <button
          type="button"
          className="pill-btn secondary dt-field__now"
          onClick={() => onChange(toDateTimeLocal(new Date()))}
        >
          Maintenant
        </button>
      )}
    </div>
  );
}
